import { observable } from 'mobx';
import { radius } from '../constants.js';
class UIStore {
  @observable height = window.innerHeight;
  @observable width = window.innerWidth;
  @observable svgTopMargin = radius;
  @observable svgBottomMargin = 150;
  constructor() {
    window.addEventListener("resize", () => {
      this.height = window.innerHeight;
      this.width = window.innerWidth;
    });
  }
}
export const observableUIStore = new UIStore();



// WEBPACK FOOTER //
// ./src/stores/ui-store.js